import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';

export default function AdminSupport() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const q = query(collection(db, 'support_requests'), orderBy('createdAt', 'desc'));
            const querySnapshot = await getDocs(q);
            const list = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setRequests(list);
        } catch (error) {
            console.error("Error fetching support requests:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleReply = (email, subject) => {
        const mailtoLink = `mailto:${email}?subject=Re: Support Request - ChatIQ&body=Hi there,%0D%0A%0D%0AIn response to your message regarding: "${subject}"...%0D%0A%0D%0ABest regards,%0D%0AChatIQ Support Team`;
        window.location.href = mailtoLink;
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        // Firestore timestamp to JS Date
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp.seconds * 1000);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const filteredRequests = requests.filter(req =>
        req.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        req.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        req.message?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <div className="p-8 text-center text-slate-500">Loading requests...</div>;

    return (
        <div className="h-full flex flex-col">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-2xl font-bold text-slate-800">Support Inbox</h2>
                    <p className="text-slate-500 text-sm">Manage incoming customer queries</p>
                </div>
                <div className="bg-white p-2 rounded-lg border border-slate-200 flex items-center shadow-sm">
                    <svg className="w-5 h-5 text-slate-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                    <input
                        type="text"
                        placeholder="Search tickets..."
                        className="bg-transparent outline-none text-sm w-64"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex-1 flex flex-col">
                <div className="overflow-auto flex-1">
                    <table className="w-full text-left border-collapse">
                        <thead className="bg-slate-50 sticky top-0 z-10">
                            <tr>
                                <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider border-b border-slate-200">Date</th>
                                <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider border-b border-slate-200">User</th>
                                <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider border-b border-slate-200">Problem Description</th>
                                <th className="p-4 text-xs font-bold text-slate-500 uppercase tracking-wider border-b border-slate-200 text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {filteredRequests.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="p-8 text-center text-slate-400 italic">No support requests found.</td>
                                </tr>
                            ) : (
                                filteredRequests.map(req => (
                                    <tr key={req.id} className="hover:bg-slate-50 transition-colors group">
                                        <td className="p-4 text-sm text-slate-500 whitespace-nowrap align-top w-40">
                                            {formatDate(req.createdAt)}
                                        </td>
                                        <td className="p-4 align-top w-64">
                                            <div className="font-semibold text-slate-800 text-sm">{req.name}</div>
                                            <div className="text-xs text-blue-500">{req.email}</div>
                                        </td>
                                        <td className="p-4 align-top">
                                            <p className="text-sm text-slate-700 leading-relaxed line-clamp-2 hover:line-clamp-none transition-all cursor-default" title={req.message}>
                                                {req.message}
                                            </p>
                                        </td>
                                        <td className="p-4 text-right align-top w-32">
                                            <button
                                                onClick={() => handleReply(req.email, req.message && req.message.substring(0, 30))}
                                                className="px-4 py-2 bg-white border border-blue-200 text-blue-600 rounded-lg text-sm font-medium hover:bg-blue-50 hover:border-blue-300 transition-all shadow-sm group-hover:shadow-md flex items-center gap-2 ml-auto"
                                            >
                                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                                                Reply
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
